/* Every card swatch class the quick-add reads (home rows, collection grid, cart upsell cards): ONE
   list shared by BOTH closures in this file, so a new surface cannot be half-covered (round-three
   review, 2026-09-25: the picked colour on an upsell card did not reach the modal because the
   active-swatch reader listed two of three; and a first fix put the list inside the preloader's
   closure, out of the modal's reach, which broke every quick-add click until the probe caught it). */
var NESW_QAD_SWATCH = (function () {
  var classes = ['.color-swatch', '.product-color-swatch', '.related-color-swatch'];
  return {
    any: classes.join(', '),
    data: classes.map(function (c) { return c + '[data-color]'; }).join(', '),
    active: classes.map(function (c) { return c + '.active'; }).join(', ')
  };
})();

/* V2 — Universal preloader for quick-add popup images. Covers every quick-add
   surface (home rows, collection page cards, cart upsell cards, the product
   page's Pair it with) so the popup hero image is in the browser cache by the
   time the user opens the modal. Without this, the modal showed a blank panel
   or the PREVIOUS product's image for 0.5–2s while the new image loaded. */
(function () {
  if (window.__neswQAPreloadInit) return;
  window.__neswQAPreloadInit = true;

  var TRIGGERS = '.nesw-row .quick-add-btn, .quick-add-btn, .related-quick-add-btn, [data-qad-open]';
  var preloaded = Object.create(null);
  function preload(url) {
    if (!url || preloaded[url]) return;
    preloaded[url] = true;
    var img = new Image();
    img.src = url;
  }

  /* Collect every image URL that this card might display in any popup:
     the default product image + every swatch's variant image so swapping
     color mid-flow stays instant. */
  function collectUrls(triggerEl) {
    var urls = [];
    if (!triggerEl) return urls;
    var wrap = triggerEl.closest('.quick-add-wrapper');
    if (wrap) {
      if (wrap.dataset.selectedColorImage) urls.push(wrap.dataset.selectedColorImage);
      if (triggerEl.dataset && triggerEl.dataset.productImage) urls.push(triggerEl.dataset.productImage);
      var card = triggerEl.closest('.collection-item, .nesw-row__card-wrap, .nesw-pw__card');
      if (card) {
        card.querySelectorAll(NESW_QAD_SWATCH.any).forEach(function (sw) {
          if (sw.dataset.variantImage) urls.push(sw.dataset.variantImage);
          if (sw.dataset.image) urls.push(sw.dataset.image);
        });
      }
    }
    var rcCard = triggerEl.closest('.product-recommendations-card');
    if (rcCard) {
      var primary = rcCard.querySelector('.related-product-img-primary');
      if (primary && (primary.currentSrc || primary.src)) urls.push(primary.currentSrc || primary.src);
      rcCard.querySelectorAll('.related-color-swatch').forEach(function (sw) {
        if (sw.dataset.image) urls.push(sw.dataset.image);
      });
    }
    return urls;
  }

  function preloadFromTrigger(triggerEl) {
    collectUrls(triggerEl).forEach(preload);
  }

  document.addEventListener('mouseenter', function (e) {
    if (!e.target || !e.target.closest) return;
    var btn = e.target.closest(TRIGGERS);
    if (!btn) return;
    preloadFromTrigger(btn);
  }, true);

  document.addEventListener('touchstart', function (e) {
    if (!e.target || !e.target.closest) return;
    var btn = e.target.closest(TRIGGERS);
    if (!btn) return;
    preloadFromTrigger(btn);
  }, { passive: true, capture: true });

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        preloadFromTrigger(e.target);
        io.unobserve(e.target);
      });
    }, { rootMargin: '400px 0px 400px 0px' });
    function observeAll() {
      document.querySelectorAll(TRIGGERS).forEach(function (btn) {
        if (btn.__neswQAPreloadObserved) return;
        btn.__neswQAPreloadObserved = true;
        io.observe(btn);
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', observeAll, { once: true });
    } else {
      observeAll();
    }
    document.addEventListener('cart:change', observeAll);
  }
})();

/* V3 — The quick-add modal (Jay 2026-09-24: "more highly functional"). One
   modal for every surface. It reads the RICH variant payload the card carries
   (`.quick-add-sizes[data-variants]`: id, color, size, extra, available, price,
   compare) and renders every choice the product has:
     - a third option (Pack Size) as pills with the price and struck compare-at
       price per value;
     - the colours as swatches (cloned from the card's swatch files when the
       card has them, text pills otherwise) that swap the photo and re-scope
       the sizes;
     - the sizes as one add row each (the one-click add stays);
     - a "Size guide" button that opens the product's guide in a second panel
       of the same sheet, from the <template data-qad-guide="<id>"> the card
       renders (snippets/nesw-size-guide-body.liquid), with the CM/IN toggle.
   The button's own `data-variants` (id, color, size, available) stays as the
   fallback for cards that carry no rich payload. */
(function () {
  if (window.__neswQadDrawerBound) return;
  window.__neswQadDrawerBound = true;

  var drawer = document.getElementById('nesw-qad-drawer');
  if (!drawer) return;
  var q = function (sel) { return drawer.querySelector(sel); };
  var sizesEl = q('[data-qad-sizes]');
  var imgEl = q('[data-qad-image]');
  var titleEl = q('[data-qad-title]');
  var priceEl = q('[data-qad-price]');
  var sizesLabelEl = q('[data-qad-sizes-label]');
  var extraWrap = q('[data-qad-extra-wrap]');
  var extraEl = q('[data-qad-extra]');
  var extraLabel = q('[data-qad-extra-label]');
  var colorsWrap = q('[data-qad-colors-wrap]');
  var colorsEl = q('[data-qad-colors]');
  var colorNameEl = q('[data-qad-colorname]');
  var guideBtn = q('[data-qad-guide-open]');
  var guidePanel = q('[data-qad-guide]');
  var guideBody = q('[data-qad-guide-body]');
  var guideTitle = q('[data-qad-guide-title]');
  var mainPanel = q('[data-qad-main]');

  /* Pack-chip proxy state: the button/card the sheet was last populated
     from, so a proxy tap can re-populate after the card chip runs. */
  var __qadLastBtn = null;
  var __qadLastCard = null;

  function esc(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  /* Focus: into the sheet on open (the close button, so a screen reader lands on the dialog and
     Tab walks its controls), back to the element that opened it on close, and Tab never leaves
     the open sheet (review finding, 2026-09-24). */
  var __qadReturnFocus = null;
  var __qadPrevOverflow = ''; /* the body's overflow before open(): the cart drawer may hold its own lock */
  function focusables() {
    var f = drawer.querySelectorAll('button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])');
    return Array.prototype.filter.call(f, function (el) { return el.offsetParent !== null; });
  }
  function open() {
    var __ae = document.activeElement;
    if (__ae && __ae !== document.body && !drawer.contains(__ae)) __qadReturnFocus = __ae; /* a re-open from inside keeps the first trigger */
    /* 🔴 Lock the page that actually scrolls (Jay 2026-09-30: no scroll behind the sheet). This theme's <html>
       carries overflow-x hidden, so body's overflow does not reach the viewport and a body-only lock let the
       page scroll behind. Lock both, restore both exactly as found. */
    if (!drawer.classList.contains('is-open')) { __qadPrevOverflow = document.body.style.overflow || ''; drawer.__qadPrevHtmlOverflow = document.documentElement.style.overflow || ''; }
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
    var first = drawer.querySelector('.nesw-qad-drawer__close') || focusables()[0];
    if (first) setTimeout(function () { try { first.focus({ preventScroll: true }); } catch (e) { first.focus(); } }, 60);
  }
  function close() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = __qadPrevOverflow; /* '' normally; 'hidden' while the cart drawer is open behind */
    document.documentElement.style.overflow = drawer.__qadPrevHtmlOverflow || '';
    showGuide(false);
    var back = __qadReturnFocus; __qadReturnFocus = null;
    if (back && back.focus && document.contains(back)) { try { back.focus({ preventScroll: true }); } catch (e) {} }
  }
  document.addEventListener('nesw:tiercart', function () {
    if (drawer.classList.contains('is-open') && typeof drawer.__neswPaintPrice === 'function') drawer.__neswPaintPrice();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || !drawer.classList.contains('is-open')) return;
    var f = focusables();
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1], cur = document.activeElement;
    if (!drawer.contains(cur)) { e.preventDefault(); (e.shiftKey ? last : first).focus(); }
    else if (e.shiftKey && cur === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && cur === last) { e.preventDefault(); first.focus(); }
  });
  function showGuide(on) {
    if (!guidePanel || !mainPanel) return;
    var wasOn = !guidePanel.hidden;
    guidePanel.hidden = !on;
    mainPanel.hidden = !!on;
    /* Each panel opens at its top, with its Back row and the close button in view (2026-09-30). */
    var sheetEl = drawer.querySelector('.nesw-qad-drawer__sheet'); if (sheetEl) sheetEl.scrollTop = 0;
    drawer.classList.toggle('is-guide', !!on);
    /* The button just pressed is hidden with its panel, so focus would fall to body: hand it to
       the Back button on the way in and to the Size guide button on the way out (only while the
       sheet is open and the state actually changed). */
    if (wasOn !== !!on && drawer.classList.contains('is-open')) {
      var next = on ? drawer.querySelector('[data-qad-guide-close]') : drawer.querySelector('[data-qad-guide-open]');
      if (next && !next.hidden) { try { next.focus({ preventScroll: true }); } catch (e) { next.focus(); } }
    }
  }

  /* The card that holds the trigger: the row card, the collection card, a
     Pair it with card, or the trigger's own quick-add wrapper. */
  function cardOf(btn) {
    return btn.closest('.nesw-row__card-wrap, .collection-item, .nesw-pw__card, .product-recommendations-card') || btn.closest('.quick-add-wrapper') || btn.parentElement;
  }

  /* The variant payload: the rich one on `.quick-add-sizes` when the card has
     it, else the trigger's own. Normalised so every variant has every field. */
  function payloadFor(btn) {
    var wrap = btn.closest('.quick-add-wrapper');
    var rich = wrap && (wrap.querySelector('.quick-add-sizes--payload') || wrap.querySelector('.quick-add-sizes'));
    /* A payload that names another product is stale (a card mid-swap): use the button's. */
    if (rich && rich.dataset.productId && btn.dataset.productId && rich.dataset.productId !== btn.dataset.productId) rich = null;
    var raw = [];
    var extraName = '';
    if (rich && rich.dataset.variants) {
      try { raw = JSON.parse(rich.dataset.variants); } catch (_) { raw = []; }
      extraName = rich.dataset.extraName || '';
    }
    if (!raw.length) {
      try { raw = JSON.parse(btn.dataset.variants || '[]'); } catch (_) { raw = []; }
    }
    if (!extraName) {
      var packRow = cardOf(btn) && cardOf(btn).querySelector('.nesw-row__packs[data-extra-name]');
      if (packRow) extraName = packRow.getAttribute('data-extra-name') || '';
    }
    var vs = raw.map(function (v) {
      return {
        id: String(v.id), color: v.color || '', size: v.size || '', extra: v.extra || '',
        available: !!v.available, price: v.price || '', compare: v.compare || '',
        cents: typeof v.cents === 'number' ? v.cents : parseInt(v.cents || '0', 10) || 0
      };
    });
    return { variants: vs, extraName: extraName };
  }

  function distinct(list, key) {
    var out = [];
    list.forEach(function (v) { var k = v[key]; if (k && out.indexOf(k) < 0) out.push(k); });
    return out;
  }
  function cheapest(pool) {
    var pick = null;
    pool.forEach(function (v) { if (!v.available) return; if (!pick || v.cents < pick.cents) pick = v; });
    if (!pick) pool.forEach(function (v) { if (!pick || v.cents < pick.cents) pick = v; });
    return pick;
  }
  /* A pack-size pill's price: the cart-pool quote when this unit would take a tier (a single does, a
     pack variant never does), else its own price with the struck compare-at. */
  /* ownerPid: the product that OWNS this pill's variant (review r7: the merged Single/Pack row holds two
     products; quoting a pack pill as the single showed a bundle at 10% off, the reverse hid the single's). */
  function pillPrice(pick, ownerPid) {
    var qq = (window.neswTierQuote && ownerPid) ? window.neswTierQuote({ productId: ownerPid, variantId: pick.id, cents: pick.cents, qty: 1 }) : null;
    if (qq) {
      var cmp = Math.round(parseFloat(String(pick.compare || '').replace(/[^0-9.]/g, '')) * 100) || 0;
      return '<span class="nesw-qad-pill__price"><del>' + esc(window.neswMoney(Math.max(cmp, qq.was))) + '</del>' + esc(window.neswMoney(qq.cents)) + '</span>';
    }
    return '<span class="nesw-qad-pill__price">' + (pick.compare ? '<del>' + esc(pick.compare) + '</del>' : '') + esc(pick.price) + '</span>';
  }
  function priceHtml(v) {
    if (!v || !v.price) return '';
    return (v.compare ? '<del>' + esc(v.compare) + '</del> ' : '') + '<span>' + esc(v.price) + '</span>';
  }

  /* Proxy chip taps (linked listings such as the tank 3-Pack / 6-Pack swap):
     click the REAL card chip, then re-populate from the (possibly swapped)
     trigger. */
  drawer.addEventListener('click', function (e) {
    var px = e.target.closest && e.target.closest('[data-qad-pack-proxy]');
    if (!px) return;
    e.preventDefault();
    e.stopPropagation();
    if (!__qadLastCard) return;
    var ref = (px.getAttribute('data-qad-pack-proxy') || '').split(':');
    var rows = __qadLastCard.querySelectorAll('.nesw-row__packs--ll');
    var rowEl = rows[parseInt(ref[0], 10)];
    var target = rowEl && rowEl.querySelectorAll('.pack-btn')[parseInt(ref[1], 10)];
    if (!target) return;
    target.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
    var refreshBtn = __qadLastCard.querySelector('.quick-add-btn, [data-qad-open]') || __qadLastBtn;
    setTimeout(function () { if (refreshBtn) populate(refreshBtn); }, 60);
  });

  function populate(btn) {
    var data = payloadFor(btn);
    var variants = data.variants;
    var pid = btn.dataset.productId || '';
    var wrap = btn.closest('.quick-add-wrapper');
    var card = cardOf(btn);
    __qadLastBtn = btn;
    __qadLastCard = card;

    var colors = distinct(variants, 'color');
    var extras = distinct(variants, 'extra');
    var hasColors = colors.length > 1;
    var hasExtras = extras.length > 1;

    /* ONE pill row for a Single <-> Multi-Pack family (Jay 2026-09-25: "One, Two, Three, Four",
       no Single / Multi-Pack switch, fewer buttons): when the card's registry holds a two-listing
       row where one listing has no extra option and the other a multi-value one, the pack row
       shows the single as its first pill (label: the sheet's data-single-pill, a theme setting,
       default "One") followed by the pack's values, each with its price. A pill that names the
       OTHER listing swaps the card (the registry chip click, exactly what the proxy row did) and
       reopens on that value. The linked row is not rendered while this applies; any other family
       keeps its proxy row. */
    var merged = null;
    if (card) {
      var regEl = card.querySelector('script[data-ll-registry]');
      var reg = null;
      if (regEl) { try { reg = JSON.parse(regEl.textContent); } catch (e) { reg = null; } }
      var llRows = reg ? card.querySelectorAll('.nesw-row__packs--ll') : [];
      /* Two shapes of a single + pack family: (a) the pack listing carries a multi-value option
         (the tee's Pack Size: Two / Three / Four), its values become the pills; (b) the pack is a
         plain listing (Foundation Tee 3-Pack, the hat bundles), one pill carrying its chip label
         ("3-Pack") with its price. The single is the chip labelled Single / One / 1 in the map
         (nesw-linked-listings), or the listing without the option in shape (a). Style and weight
         rows (Solid / Two-Tone, Lightweight / Heavyweight) have neither and stay proxy rows. */
      var isSingleLabel = function (t) { return /^(single|one|1)$/i.test((t || '').trim()); };
      for (var mi = 0; mi < llRows.length && !merged; mi++) {
        var mChips = llRows[mi].querySelectorAll('.pack-btn[data-ll-target]');
        if (mChips.length !== 2) continue;
        var pa = reg[mChips[0].getAttribute('data-ll-target')], pb = reg[mChips[1].getAttribute('data-ll-target')];
        if (!pa || !pb || !pa.variants || !pb.variants) continue;
        var xa = distinct(pa.variants, 'extra'), xb = distinct(pb.variants, 'extra');
        var mSingle = null, mPack = null, mPackChip = null;
        if (!xa.length && xb.length > 1) { mSingle = pa; mPack = pb; mPackChip = mChips[1]; }
        else if (!xb.length && xa.length > 1) { mSingle = pb; mPack = pa; mPackChip = mChips[0]; }
        else if (!xa.length && !xb.length && /pack|bundle/i.test((llRows[mi].getAttribute('aria-label') || '') + ' ' + mChips[0].textContent + ' ' + mChips[1].textContent)) {
          /* a pack row by name (row heading or a chip says Pack / Bundle), never a Style or Weight row */
          var la = isSingleLabel(mChips[0].textContent), lb = isSingleLabel(mChips[1].textContent);
          if (la && !lb) { mSingle = pa; mPack = pb; mPackChip = mChips[1]; }
          else if (lb && !la) { mSingle = pb; mPack = pa; mPackChip = mChips[0]; }
        }
        if (!mSingle) continue;
        merged = { single: mSingle, pack: mPack, values: distinct(mPack.variants, 'extra'), packLabel: (mPackChip.textContent || '').trim(), rowLabel: llRows[mi].getAttribute('aria-label') || '', rowIdx: mi };
      }
    }
    var onSingle = !!(merged && String(merged.single.id) === String(pid));

    /* Starting colour: the card's picked swatch, else the first in stock. */
    var activeColor = (wrap && wrap.dataset.selectedColor) || '';
    if (!activeColor && card) {
      var sw = card.querySelector(NESW_QAD_SWATCH.active);
      if (sw) activeColor = (sw.dataset.color || '').trim();
    }
    if (!hasColors) activeColor = '';
    else if (colors.indexOf(activeColor) < 0) {
      activeColor = '';
      for (var ci = 0; ci < colors.length; ci++) {
        if (variants.some(function (v) { return v.color === colors[ci] && v.available; })) { activeColor = colors[ci]; break; }
      }
      if (!activeColor) activeColor = colors[0];
    }
    /* Starting pack size: the card's picked chip, else the first in stock. */
    var activeExtra = (wrap && wrap.dataset.selectedExtra) || '';
    if (!hasExtras) activeExtra = '';
    else if (extras.indexOf(activeExtra) < 0) {
      activeExtra = '';
      for (var ei = 0; ei < extras.length; ei++) {
        if (variants.some(function (v) { return v.extra === extras[ei] && v.available; })) { activeExtra = extras[ei]; break; }
      }
      if (!activeExtra) activeExtra = extras[0];
    }

    function pool(extra, color) {
      return variants.filter(function (v) {
        return (!hasExtras || !extra || v.extra === extra) && (!hasColors || !color || v.color === color);
      });
    }

    drawer.__neswTrigger = btn; /* pill quotes read the product this sheet shows */
    /* Header: title, price of the current choice, view link. */
    titleEl.textContent = btn.dataset.productTitle || '';
    function paintPrice() {
      var pick = cheapest(pool(activeExtra, activeColor));
      var html = priceHtml(pick);
      /* What this item will cost with the cart as it is (Jay 2026-09-25): the Ignis cart-pool quote
         from assets/nesw-offer-bar.js (the discount's own rule and whole-dollar rounding). Struck: the
         compare-at when higher, else the full price. A pack never takes the tier, so it quotes null. */
      var qq = (pick && window.neswTierQuote) ? window.neswTierQuote({ productId: btn.dataset.productId, variantId: pick.id, cents: pick.cents, qty: 1 }) : null;
      if (qq) {
        var cmp = Math.round(parseFloat(String(pick.compare || '').replace(/[^0-9.]/g, '')) * 100) || 0;
        html = '<del>' + esc(window.neswMoney(Math.max(cmp, qq.was))) + '</del> <span>' + esc(window.neswMoney(qq.cents)) + '</span>'
          + '<em class="nesw-qad-tiernote">' + qq.pct + '% off with your cart</em>';
      }
      if (html) priceEl.innerHTML = html;
      else if (btn.dataset.productPriceHtml) priceEl.innerHTML = btn.dataset.productPriceHtml;
      else priceEl.textContent = btn.dataset.productPrice || '';
    }
    var viewEl = q('[data-qad-view]');
    function paintView() {
      if (!viewEl) return;
      var purl = btn.dataset.productUrl || '';
      if (!purl) { viewEl.style.display = 'none'; return; }
      var pick = cheapest(pool(activeExtra, activeColor));
      if (pick && (activeColor || activeExtra)) purl += (purl.indexOf('?') > -1 ? '&' : '?') + 'variant=' + pick.id;
      viewEl.setAttribute('href', purl);
      viewEl.style.display = '';
    }

    /* Photo: the card swatch's image for the colour, else the payload map,
       else the trigger's product image. */
    var colorImgs = {};
    try { colorImgs = JSON.parse(btn.dataset.colorImages || '{}'); } catch (_) {}
    var richEl = wrap && wrap.querySelector('.quick-add-sizes[data-color-images]');
    if (richEl && richEl.dataset.productId && richEl.dataset.productId !== (btn.dataset.productId || '')) richEl = null;
    if (richEl) { try { var m2 = JSON.parse(richEl.dataset.colorImages || '{}'); Object.keys(m2).forEach(function (k) { if (!colorImgs[k]) colorImgs[k] = m2[k]; }); } catch (_) {} }
    if (card) {
      card.querySelectorAll(NESW_QAD_SWATCH.data).forEach(function (sw) {
        var src = sw.dataset.variantImage || sw.dataset.image;
        if (src && !colorImgs[(sw.dataset.color || '').trim()]) colorImgs[(sw.dataset.color || '').trim()] = src;
      });
    }
    function paintImage() {
      var src = (activeColor && colorImgs[activeColor]) || (wrap && wrap.dataset.selectedColorImage) || btn.dataset.productImage || '';
      if (!src || imgEl.getAttribute('src') === src) return;
      imgEl.style.transition = 'opacity 0.12s ease';
      imgEl.style.opacity = '0';
      function reveal() { imgEl.style.opacity = '1'; }
      imgEl.onload = reveal;
      imgEl.onerror = reveal;
      imgEl.src = src;
      imgEl.alt = btn.dataset.productTitle || '';
      if (imgEl.complete && imgEl.naturalWidth > 0) reveal();
    }

    /* Linked listings (the tank 3-Pack / 6-Pack swap): the card's swap rows
       mirrored as proxies. The card's own pack-size chips are NOT mirrored any
       more: the pack row below renders that option with its prices. */
    var linkedWrap = q('[data-qad-linked-wrap]');
    if (linkedWrap) {
      var llHtml = '';
      var rows = card ? card.querySelectorAll('.nesw-row__packs--ll') : [];
      rows.forEach(function (rowEl, ri) {
        if (merged && ri === merged.rowIdx) return; /* that row is the pill row below */
        var chips = rowEl.querySelectorAll('.pack-btn');
        if (chips.length < 2) return;
        var pxRow = '';
        chips.forEach(function (c, cidx) {
          pxRow += '<button type="button" class="bundle-btn' + (c.classList.contains('active') ? ' bundle-btn-active' : '') + '" data-qad-pack-proxy="' + ri + ':' + cidx + '">' + esc(c.textContent.trim()) + '</button>';
        });
        var label = rowEl.getAttribute('aria-label') || 'Options';
        llHtml += '<div class="nesw-qad-drawer__sizes-label">' + esc(label) + '</div><div class="nesw-qad-drawer__linked-row">' + pxRow + '</div>';
      });
      linkedWrap.innerHTML = llHtml;
      linkedWrap.style.display = llHtml ? '' : 'none';
    }

    /* The third option (Pack Size): one pill per value with its price and the
       struck compare-at price, scoped to the active colour. */
    function pillHtml(label, on, avail, pick, attrs, ownerPid) {
      return '<button type="button" class="nesw-qad-pill' + (on ? ' is-on' : '') + (avail ? '' : ' is-out') + '"' + attrs + (avail ? '' : ' aria-disabled="true"') + '>'
        + '<span class="nesw-qad-pill__name">' + esc(label) + '</span>'
        + (pick && pick.price ? pillPrice(pick, ownerPid) : '')
        + '</button>';
    }
    function isAvail(v) { return !!v.available; }
    function paintExtras() {
      if (!extraWrap || !extraEl) return;
      if (merged) {
        var singleLabel = drawer.getAttribute('data-single-pill') || 'One';
        var sv = onSingle ? pool('', activeColor) : merged.single.variants;
        var html = pillHtml(singleLabel, onSingle, sv.some(isAvail), cheapest(sv), onSingle ? ' data-qx=""' : ' data-qad-ll="' + esc(merged.single.handle) + '" data-qx=""', onSingle ? pid : merged.single.id);
        if (merged.values.length) {
          merged.values.forEach(function (x) {
            var pv = onSingle ? merged.pack.variants.filter(function (v) { return v.extra === x; }) : pool(x, activeColor);
            html += pillHtml(x, !onSingle && x === activeExtra, pv.some(isAvail), cheapest(pv), (onSingle ? ' data-qad-ll="' + esc(merged.pack.handle) + '"' : '') + ' data-qx="' + esc(x) + '"', onSingle ? merged.pack.id : pid);
          });
        } else {
          /* A plain pack listing: one pill, the chip's label, swapping to that listing. */
          var onPack = String(merged.pack.id) === String(pid);
          var pkv = onPack ? pool('', activeColor) : merged.pack.variants;
          html += pillHtml(merged.packLabel || 'Pack', onPack, pkv.some(isAvail), cheapest(pkv), onPack ? ' data-qx=""' : ' data-qad-ll="' + esc(merged.pack.handle) + '" data-qx=""', onPack ? pid : merged.pack.id);
        }
        if (extraLabel) extraLabel.textContent = merged.pack.extraName || (merged.values.length ? data.extraName : '') || merged.rowLabel || 'Pack size';
        extraEl.innerHTML = html;
        extraWrap.style.display = '';
        return;
      }
      if (!hasExtras) { extraWrap.style.display = 'none'; extraEl.innerHTML = ''; return; }
      if (extraLabel) extraLabel.textContent = data.extraName || 'Option';
      extraEl.innerHTML = extras.map(function (x) {
        var p = pool(x, activeColor);
        var avail = p.some(function (v) { return v.available; });
        var pick = cheapest(p);
        return '<button type="button" class="nesw-qad-pill' + (x === activeExtra ? ' is-on' : '') + (avail ? '' : ' is-out') + '" data-qx="' + esc(x) + '"' + (avail ? '' : ' aria-disabled="true"') + '>'
          + '<span class="nesw-qad-pill__name">' + esc(x) + '</span>'
          + (pick && pick.price ? pillPrice(pick, pid) : '')
          + '</button>';
      }).join('');
      extraWrap.style.display = '';
    }

    /* Colours as swatches: the card's swatch visuals (file image or colour)
       when it has them, a text pill otherwise. */
    var cardSwatches = {};
    if (card) {
      card.querySelectorAll(NESW_QAD_SWATCH.data).forEach(function (sw) {
        cardSwatches[(sw.dataset.color || '').trim()] = sw;
      });
    }
    function paintColors() {
      if (!colorsWrap || !colorsEl) return;
      if (!hasColors) { colorsWrap.style.display = 'none'; colorsEl.innerHTML = ''; return; }
      colorsEl.innerHTML = colors.map(function (c) {
        var avail = pool(activeExtra, c).some(function (v) { return v.available; });
        var sw = cardSwatches[c];
        var cls = 'nesw-qad-color' + (c === activeColor ? ' is-on' : '') + (avail ? '' : ' is-out');
        if (sw) {
          var img = sw.querySelector('img');
          var bg = sw.style.backgroundColor || sw.style.background || '';
          var inner = (img && img.getAttribute('src') && img.style.display !== 'none') ? '<img src="' + esc(img.getAttribute('src')) + '" alt="">' : '';
          return '<button type="button" class="' + cls + ' nesw-qad-color--swatch" data-qc="' + esc(c) + '" title="' + esc(c) + '" aria-label="' + esc(c) + '" style="background:' + esc(bg) + '">' + inner + '</button>';
        }
        return '<button type="button" class="' + cls + '" data-qc="' + esc(c) + '">' + esc(c) + '</button>';
      }).join('');
      if (colorNameEl) colorNameEl.textContent = activeColor ? '· ' + activeColor : '';
      colorsWrap.style.display = '';
    }

    /* Sizes: one add row per size in the current (pack, colour) pool; a
       product with no real size option gets one plain add. */
    function paintSizes() {
      while (sizesEl.firstChild) sizesEl.removeChild(sizesEl.firstChild);
      var p = pool(activeExtra, activeColor);
      var sizes = distinct(p, 'size');
      var byId = function (v) {
        var add = document.createElement('button');
        add.type = 'button';
        add.className = 'nesw-qad-row__add';
        add.dataset.variantId = v.id;
        add.dataset.size = v.size || '';
        add.dataset.productId = pid;
        add.textContent = 'Add to cart';
        return add;
      };
      if (sizes.length <= 1) {
        if (sizesLabelEl) sizesLabelEl.style.display = 'none';
        var only = cheapest(p);
        var single = document.createElement('div');
        single.className = 'nesw-qad-row nesw-qad-row--single';
        if (only && only.available) {
          var addOne = byId(only);
          addOne.style.width = '100%';
          single.appendChild(addOne);
        } else {
          var soldOne = document.createElement('span');
          soldOne.className = 'nesw-qad-sold';
          soldOne.textContent = 'Sold out';
          single.appendChild(soldOne);
        }
        sizesEl.appendChild(single);
        return;
      }
      if (sizesLabelEl) { sizesLabelEl.style.display = ''; sizesLabelEl.textContent = 'Select size'; }
      sizes.forEach(function (s) {
        var vs = p.filter(function (v) { return v.size === s; });
        var v = vs.filter(function (x) { return x.available; })[0] || vs[0];
        var inStock = vs.some(function (x) { return x.available; });
        var row = document.createElement('div');
        row.className = 'nesw-qad-row';
        var name = document.createElement('span');
        name.className = 'nesw-qad-row__name' + (inStock ? '' : ' nesw-qad-row__name--oos');
        name.textContent = s;
        row.appendChild(name);
        if (inStock) row.appendChild(byId(v));
        else {
          var sold = document.createElement('span');
          sold.className = 'nesw-qad-sold';
          sold.textContent = 'Sold out';
          row.appendChild(sold);
        }
        sizesEl.appendChild(row);
      });
    }

    /* Size guide: the card's template for this product, if any. */
    var guideTpl = pid ? document.querySelector('template[data-qad-guide="' + pid + '"]') : null;
    if (guideBtn) guideBtn.hidden = !guideTpl;
    drawer.__qadGuideTpl = guideTpl;
    drawer.__qadGuideTitle = btn.dataset.productTitle || '';

    function repaint() { paintPrice(); paintView(); paintImage(); paintExtras(); paintColors(); paintSizes(); }
    drawer.__neswPaintPrice = function () { paintPrice(); paintExtras(); }; /* the cart changed while open: re-quote */
    repaint();

    if (extraEl) extraEl.onclick = function (e) {
      var b = e.target.closest('[data-qx]');
      if (!b || b.classList.contains('is-out')) return;
      var ll = b.getAttribute('data-qad-ll');
      if (ll && card) {
        /* A pill that names the other listing: swap the card through its registry chip (the
           same door the proxy row used), remember the value so the sheet reopens on it. */
        var chip = card.querySelector('.pack-btn[data-ll-target="' + ll + '"]');
        if (!chip) return;
        chip.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
        /* The swap (nesw-pack-swap.js applySwap, synchronous in the click) rewrites the card and
           DELETES the wrapper's selectedExtra, so the tapped value is written AFTER it, or the pack
           reopens on its default (Jay 2026-09-25: One -> Four landed on Two). */
        var swappedWrap = card.querySelector('.quick-add-wrapper') || wrap;
        if (swappedWrap) { if (b.dataset.qx) swappedWrap.dataset.selectedExtra = b.dataset.qx; else delete swappedWrap.dataset.selectedExtra; }
        var refreshBtn = card.querySelector('.quick-add-btn, [data-qad-open]') || btn;
        setTimeout(function () { populate(refreshBtn); }, 60);
        return;
      }
      activeExtra = b.dataset.qx;
      repaint();
    };
    if (colorsEl) colorsEl.onclick = function (e) {
      var b = e.target.closest('[data-qc]');
      if (!b || b.classList.contains('is-out')) return;
      activeColor = b.dataset.qc;
      repaint();
    };
  }

  /* Open for any `.quick-add-btn` (the pulsing corner disc on cards) or `[data-qad-open]`
     (the Pair it with card's Add).
     Capture phase + stopImmediatePropagation blocks the collection sections'
     own popup openers from firing a second drawer. */
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var btn = e.target.closest('.quick-add-btn, [data-qad-open]');
    if (!btn) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    populate(btn);
    showGuide(false);
    open();
  }, true);

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    if (e.target.closest('[data-qad-close]')) { e.preventDefault(); e.stopPropagation(); close(); return; }
    if (e.target.closest('[data-qad-guide-open]')) {
      e.preventDefault();
      var tpl = drawer.__qadGuideTpl;
      if (!tpl || !guideBody) return;
      guideBody.innerHTML = '';
      if (guideTitle) guideTitle.textContent = drawer.__qadGuideTitle || '';
      var src = tpl.getAttribute('data-qad-guide-src');
      if (tpl.content.childNodes.length || !src) {
        guideBody.appendChild(tpl.content.cloneNode(true));
      } else {
        /* Cards carry no guide (N-46); fetch this product's once, keep it in the template so a
           second press (and the CM/IN toggle) works offline, and ignore a late answer for a
           product the sheet has moved on from. */
        guideBody.innerHTML = '<p class="nesw-qad-guide-loading">Loading the size guide.</p>';
        var want = tpl;
        if (want.__neswGuideLoading) { showGuide(true); return; } /* a second press while the first fetch runs */
        want.__neswGuideLoading = true;
        fetch(src + '?view=qad-guide', { credentials: 'same-origin' })
          .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
          .then(function (html) {
            if (!html.trim()) throw new Error('empty');
            want.innerHTML = html; want.__neswGuideLoading = false;
            if (drawer.__qadGuideTpl !== want || guidePanel.hidden) return;
            guideBody.innerHTML = '';
            guideBody.appendChild(want.content.cloneNode(true));
          })
          .catch(function () {
            want.__neswGuideLoading = false;
            if (drawer.__qadGuideTpl !== want) return;
            guideBody.innerHTML = '';
            var p = document.createElement('p'); p.className = 'nesw-qad-guide-loading';
            p.textContent = 'The size guide did not load. ';
            var a = document.createElement('a'); a.href = src; a.textContent = 'Open the product page';
            p.appendChild(a); guideBody.appendChild(p);
          });
      }
      showGuide(true);
      return;
    }
    if (e.target.closest('[data-qad-guide-close]')) { e.preventDefault(); showGuide(false); return; }
    /* CM / IN inside the guide panel. */
    var unit = e.target.closest('.nesw-qad-drawer__guide .unit-btn[data-unit]');
    if (unit) {
      e.preventDefault();
      var u = unit.dataset.unit;
      guidePanel.querySelectorAll('.unit-btn').forEach(function (b) { b.classList.toggle('active', b === unit); });
      guidePanel.querySelectorAll('td[data-cm][data-in]').forEach(function (td) { td.textContent = td.dataset[u] || td.textContent; });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || !drawer.classList.contains('is-open')) return;
    if (guidePanel && !guidePanel.hidden) showGuide(false); else close();
  });

  function setAdded(btn) {
    btn.classList.add('nesw-qad-row__add--added');
    while (btn.firstChild) btn.removeChild(btn.firstChild);
    var svgNS = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(svgNS, 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '3');
    svg.setAttribute('stroke-linecap', 'round');
    svg.setAttribute('stroke-linejoin', 'round');
    var poly = document.createElementNS(svgNS, 'polyline');
    poly.setAttribute('points', '20 6 9 17 4 12');
    svg.appendChild(poly);
    btn.appendChild(svg);
    var lbl = document.createElement('span');
    lbl.textContent = 'Added';
    btn.appendChild(lbl);
  }

  document.addEventListener('click', function (e) {
    var add = e.target.closest && e.target.closest('.nesw-qad-row__add');
    if (!add || add.disabled) return;
    e.preventDefault(); e.stopPropagation();
    var vid = add.dataset.variantId;
    if (!vid) return;
    var original = add.textContent;
    add.disabled = true;
    add.textContent = 'Adding…';
    /* Canonical add (fires Meta AddToCart + reconciles /cart.js + cart:change). */
    window.neswAddToCart(vid, 1)
      .then(function () {
        setAdded(add);
        window.__neswScrollCartTopAfterUpdate = true;
        if (typeof window.updateCart === 'function') window.updateCart();
        else if (typeof window.updateCartCount === 'function') window.updateCartCount();
        if (typeof window.refreshCartPage === 'function') window.refreshCartPage(); /* the /cart page's lines */
        setTimeout(function () {
          close();
          if (typeof window.openCartDrawer === 'function') window.openCartDrawer();
        }, 700);
      })
      .catch(function () {
        add.textContent = 'Error';
        setTimeout(function () { add.disabled = false; add.textContent = original; }, 1600);
      });
  });
})();
